import { render, staticRenderFns } from "./AiButton.vue?vue&type=template&id=631f3570"
import script from "./AiButton.vue?vue&type=script&lang=js"
export * from "./AiButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports